export var StripeSubscription;
(function (StripeSubscription) {
    StripeSubscription[StripeSubscription["STARTER"] = 0] = "STARTER";
    StripeSubscription[StripeSubscription["PRO"] = 1] = "PRO";
    StripeSubscription[StripeSubscription["PREMIUM"] = 2] = "PREMIUM";
})(StripeSubscription || (StripeSubscription = {}));
//# sourceMappingURL=stripe-subscription.enum.js.map